'use client'

import { SelectionDictionaryParams, dictionaryQueries } from '../../api'
import { Dictionary } from '../../lib'
import { QueryHandler } from '@/shared/ui/query-handler'
import { UseQueryResult } from '@tanstack/react-query'
import { SimpleImageCard, SimpleImageCardProps } from '@/shared/ui/cards/image-card'
import { cn } from '@/shared/lib/classnames'
import { ValueOf } from 'next/dist/shared/lib/constants'

interface ComponentProps extends Omit<SimpleImageCardProps, 'onSelect' | 'title' | 'alt' | 'src' | 'description'> {
  dictionary: SelectionDictionaryParams
  valueField?: keyof Dictionary
  descriptionField?: keyof Dictionary
  titleField?: keyof Dictionary
  imageField?: keyof Dictionary
  value?: ValueOf<Dictionary>
  onSelect?(option?: Partial<Dictionary>, value?: ValueOf<Dictionary>): void
}

export default function Component({
  valueField = 'id',
  descriptionField = 'description',
  imageField = 'image',
  titleField = 'name',
  value,
  dictionary,
  onSelect,
  ...props
}: ComponentProps) {
  const dictionaryQuery = dictionaryQueries.useGet(dictionary)

  return (
    <div className="flex flex-wrap gap-3">
      <QueryHandler queryResult={dictionaryQuery as UseQueryResult}>
        {dictionaryQuery.data?.map((item, index) => {
          return (
            <SimpleImageCard
              {...props}
              key={index}
              alt={String(item?.[titleField] || '')}
              title={String(item?.[titleField] || '')}
              src={String(item?.[imageField] || '')}
              description={String(item?.[descriptionField] || '')}
              className={cn(
                'border grow py-3 rounded-sm bg-secondary/60',
                value == item?.id && 'border-primary bg-secondary/40',
              )}
              titleClassName="font-normal"
              onClick={() => onSelect && onSelect(item, item[valueField])}
            />
          )
        })}
      </QueryHandler>
    </div>
  )
}
